import {SmallFooterSchema, PropsWithTheme} from '../types';
import theme from './theme';

const smallFooter = (props: PropsWithTheme): SmallFooterSchema => theme(props).smallFooter;

export const smallFooterBgColor = (props: PropsWithTheme): string => smallFooter(props).backgroundColor;
export const smallFooterTextColor = (props: PropsWithTheme): string => smallFooter(props).textColor;
export const smallFooterLinkColor = (props: PropsWithTheme): string => smallFooter(props).linkColor;
